import DiffMatchPatch from "diff-match-patch";
import ExcelJS from "exceljs";

export const getRedlineTextForExcel = (anchorText: string, text: string) => {
  const richText: ExcelJS.RichText[] = [];

  const dmp = new DiffMatchPatch();
  const diffs = dmp.diff_main(anchorText, text);
  dmp.diff_cleanupSemantic(diffs);

  diffs.forEach(([op, text]) => {
    if (!text) {
      return;
    }

    switch (op) {
      case DiffMatchPatch.DIFF_INSERT:
        richText.push({ font: { color: { argb: "FF2563EB" }, underline: true }, text: text });
        break;
      case DiffMatchPatch.DIFF_DELETE:
        richText.push({ font: { color: { argb: "FFDC2626" }, strike: true }, text: text });
        break;
      case DiffMatchPatch.DIFF_EQUAL:
        richText.push({ text: text });
        break;
    }
  });

  return richText;
};
